import React, { FC } from 'react';
import cx from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';
import IconButton from '@material-ui/core/IconButton';
import SvgIcon from '@material-ui/core/SvgIcon';

import { OpenIcon } from '~/img';

const LinkButton: FC<{ handleOpen?: () => void; inline?: boolean; [x: string]: any }> = (props) => {
  const { handleOpen, inline = false, ...rest } = props;
  const classes = useStyles();
  return (
    <div className={cx(classes.openIcon, { [classes.inline]: inline })}>
      <IconButton onClick={handleOpen} {...rest}>
        <SvgIcon>
          <OpenIcon title='show' />
        </SvgIcon>
      </IconButton>
    </div>
  );
};

const useStyles = makeStyles(() => ({
  openIcon: {
    position: 'relative',
    width: 14,
    height: 14,
    '& button': {
      position: 'absolute',
      top: -6,
      width: 14,
      height: 14,
      '& svg': {
        width: 14,
        height: 14,
      },
    },
  },
  inline: {
    marginRight: 3,
    '& button': {
      top: -8,
      left: -1,
    },
  },
}));

export default LinkButton;
